import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { toast } from "react-toastify"
import BasicErrorMessage from "./BasicErrorMessage"

const Container = styled.div`
  margin-right: -5px !important;
  margin-left: -5px !important;

  > .col,
  > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px;
  }
`

export default class WidgetContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onReload: PropTypes.func.isRequired,
    errorMessageKey: PropTypes.string,
  }

  static defaultProps = {
    errorMessageKey: null,
  }

  componentDidMount = () => {
    this.showErrorMessage(this.props.errorMessageKey)
  }

  componentWillReceiveProps = (nextProps) => {
    this.showErrorMessage(nextProps.errorMessageKey)
  }

  /** Show the error message toast, if there is an error message */
  showErrorMessage = (textKey) => {
    if (textKey && !toast.isActive(this.errorToastId)) {
      toast.dismiss() // Clear other toasts
      this.errorToastId = toast(
        <BasicErrorMessage
          messageKey={textKey}
          followUpCommand={this.props.onReload}
          followUpTextKey="Common.TryAgain"
        />,
        {
          type: toast.TYPE.ERROR,
        }
      )
    }
  }

  render() {
    return (
      <Container id="widget-container" className="row">
        {this.props.children}
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WidgetContainer.jsx